import { useTranslation } from '@cobliteam/i18n';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';

type InactiveFleetBannerProps = {
  /** A dica de trocar de frota só faz sentido quando o usuário tem alguma frota ativa para ir. */
  showSwitchFleetHint: boolean;
};

/**
 * Banner fixo exibido no topo da página de boletos quando a frota está inativa
 * (pendência de pagamento ou cancelamento): todo o resto do painel fica inacessível.
 */
const InactiveFleetBanner = ({ showSwitchFleetHint }: InactiveFleetBannerProps) => {
  const { t } = useTranslation('business-manager');

  return (
    <div role='alert' data-testid='inactive-fleet-banner' className='flex items-start gap-3 border-danger-6 border-b bg-danger-2 px-6 py-4'>
      <Icon name='triangle-alert' size='md' className='mt-0.5 shrink-0 text-danger-9' />
      <div className='flex flex-col gap-1'>
        <Typography variant='text-md' className='font-semibold text-danger-11'>
          {t('inactive_fleet.banner.title')}
        </Typography>
        <Typography variant='text-sm' className='text-danger-11'>
          {t('inactive_fleet.banner.description')}
        </Typography>
        {showSwitchFleetHint && (
          <Typography variant='text-sm' data-testid='inactive-fleet-banner-switch-hint' className='text-danger-9'>
            {t('inactive_fleet.banner.switch_fleet_hint')}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default InactiveFleetBanner;
